import "../styles/loading.scss";

export const Loading = () => {
  return (
    <div className="container-loading">
      <p>Carregando...</p>
      <div className="circle-box">
        <span className="circle"></span>
        <span className="circle"></span>
        <span className="circle"></span>
      </div>
    </div>
  );
};
